import './ManualCompletion.scss';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Input from '../Input/Input';
import Packages from '../../api/controllers/Packages/Packages';
import Error from '../Error/Error';
import Button from '../Button/Button';

// General ManualCompletion Component
const ManualCompletion = ({ pkg, setModalOpen, refetchPackages }) => {
  const [reason, setReason] = useState();
  const [error, setError] = useState();

  const manuallyCompletePackage = () => {
    Packages.manuallyComplete(pkg.package.id, reason)
      .then(() => {
        refetchPackages();
        setModalOpen(false);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  return (
    <div className="manual_completion_container">
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${
                  error.length > 1 ? 's' : ''
                } prohibited this item from being saved: `
              : ''
          }
        />
      )}
      <div className="manual_completion_warning">
        <div>
          You are about to manually mark a package as <span className="bold">complete</span>. It
          will no longer appear in the warehouse, and will not be able to be loaded on to delivery
          vehicles or export trailers.
        </div>
        <div>
          If you are sure that this is what you want to do, please enter the reason for this manual
          completion in the box below:
        </div>
      </div>
      <div className="manual_completion_form">
        This package is no longer in the warehouse, because...
        <Input autofocus={true} value={reason} setValue={setReason} />
      </div>
      <Button
        className="manual_completion_button"
        onClick={manuallyCompletePackage}
        label={`Mark ${pkg.packageName} as complete`}
      />
    </div>
  );
};

ManualCompletion.propTypes = {
  pkg: PropTypes.object,
  setModalOpen: PropTypes.func,
  refetchPackages: PropTypes.func,
};

export default ManualCompletion;
